import { render, staticRenderFns } from "./routes-list.vue?vue&type=template&id=26802e72"
import script from "./routes-list.vue?vue&type=script&lang=js"
export * from "./routes-list.vue?vue&type=script&lang=js"
import style0 from "./routes-list.vue?vue&type=style&index=0&id=26802e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports